import React from "react";
import InsomniaHero from "../components/insomnia/InsomniaHero";
import InsomniaContent from "../components/insomnia/InsomniaContent";

const Insomnia = () => {
  return (
    <>
      <InsomniaHero />
      <InsomniaContent />
    </>
  );
};

export default Insomnia;
